import { useApi } from '../lib/useApi';
import { money, fmtDate } from '../lib/format';
import { Loader, Empty } from '../ui/common';

export default function Accounts({ config }) {
  const currency = config.currency || '₹';
  const { data, loading, error } = useApi('/api/accounts/balances');
  return (
    <div>
      {error && <div className="err" style={{ marginBottom: 16 }}>{error}</div>}
      {loading || !data ? <Loader /> : (
        <>
          <div className="cm-form-section-card" style={{ background: 'var(--chip-bg)', borderColor: '#dbeafe', marginBottom: 20 }}>
            <div style={{ fontSize: '0.8rem', color: 'var(--brand)', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Total Liquid Cash &amp; Bank Balance
            </div>
            <div style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--brand)', marginTop: 4 }}>
              {money(data.totalCurrentBalance, currency)}
            </div>
          </div>

          {data.accounts.length === 0 ? (
            <Empty>No bank accounts configured.</Empty>
          ) : (
            <div className="cm-table-card">
              <table className="cm-table">
                <thead>
                  <tr>
                    <th>Account Name</th>
                    <th>Beginning Balance</th>
                    <th>Deposits / Income</th>
                    <th>Withdrawals / Expenses</th>
                    <th>Adjustments</th>
                    <th>Current Live Balance</th>
                    <th>Last Checked Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.accounts.map((a) => (
                    <tr key={a.account}>
                      <td style={{ fontWeight: 800, color: 'var(--ink)' }}>{a.account}</td>
                      <td>{money(a.beginningBalance, currency)}</td>
                      <td style={{ color: 'var(--brand)', fontWeight: 700 }}>+{money(a.deposits, currency)}</td>
                      <td style={{ color: 'var(--ink)', fontWeight: 700 }}>-{money(a.withdrawals, currency)}</td>
                      <td>{money(a.adjustments, currency)}</td>
                      <td style={{ fontWeight: 800, fontSize: '1.05rem', color: a.currentBalance < 0 ? '#0f172a' : '#224eae' }}>
                        {money(a.currentBalance, currency)}
                      </td>
                      <td style={{ color: 'var(--muted)', fontSize: '0.85rem' }}>
                        {a.lastChecked ? fmtDate(a.lastChecked) : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
